import { defineStore } from "pinia"
import { ref } from "vue"

export const useToggleThemeStore = defineStore("toggleTheme", () => {
  
// Load the initial theme from localStorage or fallback to "night"
const activeTheme = ref(localStorage.getItem("activeTheme") || "day");

// Apply the theme on initialization
const applyTheme = () => {
  document.documentElement.setAttribute("data-theme", activeTheme.value);

  if (activeTheme.value === "night") {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
};

// Apply the theme immediately
applyTheme();

const toggleTheme = () => {
  // Toggle the theme
  activeTheme.value = activeTheme.value === "day" ? "night" : "day";

  // Save the active theme to localStorage
  localStorage.setItem("activeTheme", activeTheme.value);

  // Apply the new theme
  applyTheme();
};

return { activeTheme, toggleTheme };
})
